module.exports = __webpack_public_path__ + "img/icon-right-arrow.5460624c.svg";